/**
 * 数据表管理页面
 */
export default {
  dbl_data_table_title: "Table",
  dbl_data_table_enter_analysis: "Enter Analysis",
  dbl_data_table_level_one: "Level One Category",
  dbl_data_table_level_two: "Level Two Category",
  dbl_data_table_search: "Search by name, description, field or administrator",
  dbl_data_table_description: "Description",
  dbl_data_table_name: "Table",
  dbl_data_table_cycle: "Update Cycle",
  dbl_data_table_usage_count: "Usage Count",
  dbl_data_table_database_type: "Database Type",
  dbl_data_table_database_name: "Database Name",
  dbl_data_table_creation_time: "Create Time",
  dbl_data_table_person_in_charge: "Administrator",
  dbl_data_table_operation: "Actions",
  dbl_data_table_analysis: "Analysis",
  dbl_data_table_details: "Details",
  dbl_data_table_edit: "Edit",
  dbl_data_table_structure: "Table Structure",
  dbl_data_table_column_name: "Column Name",
  dbl_data_table_data_type: "Data Type",
  dbl_data_table_nullable: "Nullable",
  dbl_data_table_primary_key: "Primary Key",
  dbl_data_table_default_value: "Default Value",
  dbl_data_table_comment: "Comment",
  dbl_data_table_data_preview: "Data Preview",
  dbl_data_table_more_three: "Select up to 3, please cancel and then select",
  dbl_data_table_total: "Total {total} Items",
  dbl_data_table_tooltip: "The system table information does not match the database table information. Please contact the data classmate and v_blljli to check.",
  dbl_data_table_not_show: "Sensitive fields are not displayed",
  dbl_data_table_refresh_bubble: "The default refresh frequency for data table information is once every hour. Clicking the refresh button will immediately refresh the data table information.",
  dbl_data_table_refresh_success: "Data table information refresh success",
  dbl_data_table_refresh_error: "Data table information refresh error",
  dbl_data_table_refresh_btn: "Refresh",
  dbl_data_table_not_same: "Cannot join a table if it is not the same data source",
	
  dbl_data_table_edit_title: "Edit Table",
  dbl_data_table_origin_name: "Origin Name",
  dbl_data_table_display_name: "Display Name",
  dbl_data_table_field_name: "Field Name",
  dbl_data_table_field_type: "Field Type",
  dbl_data_table_metric_dimension: "Dimension/Metric",
  dbl_data_table_field_desc: "Field Description",
  dbl_data_table_string: 'String',
  dbl_data_table_date: 'Datetime',
  dbl_data_table_time: 'Time',
  dbl_data_table_number: 'Int',
  dbl_data_table_float: 'Float',
  dbl_data_table_decimal_places: 'Decimal places',
  dbl_data_table_percent: 'Percentage',
  dbl_data_table_dimension_value_settings: 'Dimension Value Settings',
  dbl_data_table_origin: 'Original value',
  dbl_data_table_associated_dimension_table: 'Associated dimension table',
  dbl_data_table_system: 'Automatic matching',
  dbl_data_table_customize: 'Custom association',
  dbl_data_table_include_dimension_total_value: 'Include Dimension Total Value',
  dbl_data_table_include: 'Include',
  dbl_data_table_exclude: 'Exclude',
  dbl_data_table_dimension: 'Dimension',
  dbl_data_table_metric: 'Metric',
  dbl_data_table_edit_leave: 'Leave the current data table editing?',
  dbl_data_table_check_date_success: 'Conversion successful',
  dbl_data_table_check_date_fail: 'Unable to convert to date type',
  dbl_data_table_size: "Table size",
};